import { SERVICE_NAMESPACE } from 'common';

// Must remove sentinel2 from url to enable successful atlas call.
export const URL = (apiUrl = '', apexAccountId) => `${apiUrl}/atlas/api/v1/accounts/${apexAccountId}`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/ATLAS`;

export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const FAILURE = `${NAMESPACE}/FAILURE`;
export const ATLAS_REQUEST = `${NAMESPACE}/REQUEST`;



// WEBPACK FOOTER //
// ./src/services/atlasRequest/constants.js